<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName" >
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警诊断
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn url="extra/alarmDiagnosis/export/alarmCorrelationExport" :params="seefrom" method="post" :needUserId="true"></downloadBtn>
        </div>
        <div class="searchForm1" >
          <searchForm
            :items="items"
            :formPlus="form_jsgl"
            ref="searchForm_jsgl"
          >
            <template slot="last">
              <el-form-item label="应用系统">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.systemId"
                  placeholder="请选择应用系统"
                  @change="selectDeviceType"
                >
                  <el-option
                    v-for="item in SystemId"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select
                  :popper-append-to-body="false"
                  placeholder="请输入设备类型"
                  v-model="seefrom.deviceType"
                >
                  <el-option :value="''">请选择</el-option>
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="区域选择">
                <el-input
                  placeholder="请选择区域"
                  v-model="seefrom.curAreaName"
                  @focus="changeAreaMode(1)"
                ></el-input>
              </el-form-item>

              <el-form-item label="设备名称">
                <el-input
                  placeholder="请输入设备名称"
                  v-model="seefrom.deviceName"
                ></el-input>
              </el-form-item>
              <el-form-item label="设备编号">
                <el-input
                  placeholder="请输入设备编号"
                  v-model="seefrom.deviceMark"
                ></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="extra/alarmDiagnosis/alarmCorrelation"
            :parent="self"
            :config="config"
            :other="other"
            ref="list"
          >
            <template slot="last">
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="seeEmpAll(scope.$index, scope.row)"
                  >查看人员</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>

        <el-dialog
          class="editDialog"
          :visible.sync="seeDisplayForm"
          title="人员详情"
          :close-on-click-modal="false"
        >
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            max-height="600px"
            ref="Table"
          >
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column prop="deptNames" label="部门"> </el-table-column>
            <el-table-column prop="groupNames" label="功能分组"> </el-table-column>
            <el-table-column prop="alarmTypeStr" label="告警方式"> </el-table-column>
            <el-table-column prop="userPhone" label="联系电话" width="120"> </el-table-column>

          </el-table>
        </el-dialog>
        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return {

        tabName: "jsgl",
        form_jsgl: {},
        title: "",
        other: {},
        items: [],
        seefrom: {
          systemId: "",
          deviceType: "",
          regionId: "",
          curAreaName: "",
          deviceName: "",
          deviceMark: ""
        },
        addEquipment: {
          systemId: "",
          deviceType: "",
          pumpType: null,
        },

        //区域树是否显示
        areaTreeVisible: false,
        areaTreeMode: true,
        //选择区域树模式 查询 ？ 新增 ？
        areaMode: 1,
        seeDisplayForm: false,
        displayForm: false,
        SystemId: [],
        options: [],
        //上传文件
        addArr: [],
        tableData: [],
        checkData: [],
        //设备额外信息
        equipment: {
          protocolTypeName: "",
        },
        //设备种类（网关）
        deviceKind: "",
      };
    },
    computed: {
      self() {
        return this;
      },
      config() {
        return [
          {
            prop: "deviceName",
            label: "设备名称",
          },
          {
            prop: "deviceMark",
            label: "设备编号",
          },
          {
            prop: "statusStr",
            label: "设备状态",
          },
          {
            prop: "typeName",
            label: "设备类型",
          },
          {
            prop: "areaName",
            label: "安装点",
          },
          {
            prop: "parentArea",
            label: "上级区域",
          },
          {
            prop: "deptName",
            label: "部门",
          },

          // {
          //   prop: "empName",
          //   label: "姓名",
          // },
          // {
          //   prop: "empPhone",
          //   label: "电话",
          // },
          {
            prop: "empNumber",
            label: "人员数量",
          }
        ];
      },
      dt() {
        return dt.map(({ label }) => label);
      },
    },
    components: {
      normalNav: () => import("public/normalNav"),
      searchForm: () => import("public/searchForm"),
      easyTable: () => import("public/easyTable"),
      mountPoint: () => import("public/mountPoint"),
      downloadBtn:() => import('public/download'),
    },
    methods: {
      //初始化
      initSystemId() {
        //console.log("应用系统");
        this.$axiosget(
          "manager/operatingSystemApi/getOperatingSystemsByCompanyId",
          {
            params: {
              compayId: localStorage.getItem("companyId"),
            },
          }
        ).then((res) => {
          this.SystemId = res.data.data;
        });
      },
      exportData(){

      },
      //搜索
      subSeefrom() {
        //存储
        if(this.seefrom.deviceType == '' && this.seefrom.systemId != ''){
          this.$confirm("数据过多，请务必选择设备类型", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "返回",
            type: "warning",
          }).then(() => {

          });
          return;
        }
        //console.log(this.seefrom.regionId);
        //console.log(this.seefrom.deviceType);
        localStorage.setItem("backsearch_deviceType", this.seefrom.deviceType);
        localStorage.setItem("backsearch_regionId", this.seefrom.regionId);
        localStorage.setItem("backsearch_deviceName", this.seefrom.deviceName);
        localStorage.setItem("backsearch_deviceMark", this.seefrom.deviceMark);
        this.other = this.seefrom;
        this.$refs.list.pageToOne();
        this.$nextTick(this.$refs.list.getData);
      },
      //区域树选择完回调
      selRegionData(a, ...b) {
        let mode = this.areaMode;
        if (mode === 1) {
          this.seefrom.regionId = a.id;
          this.seefrom.curAreaName = a.name;
        }
      },
      //设备类型
      selectDeviceType(value) {
        this.seefrom.deviceType = "";
        //console.log(value, "id");
        this.$axiosget("manager/operatingSystemApi/getDeviceTypeByOperatingId", {
          params: {
            id: value,
          },
        }).then((res) => {
          this.options = res.data.data;
          //console.log(this.options, "options");
        });
      },
      //设备类型变更
      changeEquipment(val) {
        this.equipment = this.options.find((e) => val === e.id);
        //console.log(this.equipment, "equipment");
        //判断设备种类
        this.deviceKind = this.equipment.deviceKind;
        this.addEquipment.protocolType = this.equipment.protocolType;
      },
      //选择区域模式变化
      changeAreaMode(mode) {
        this.areaTreeVisible = true;
        if (mode === 1) this.areaTreeMode = true;
        if (mode === 2) this.areaTreeMode = false;
        this.areaMode = mode;
      },

      reset() {
        this.seefrom = {
          systemId: "",
          deviceType: "",
          areaId: "",
          deviceName: "",
          deviceMark: ""
        };
      },
      //人员详情
      seeEmpAll(index, row) {
        this.tableData = [];
        this.seeDisplayForm = true;
        this.$axiosget("operation/empApi/getEmpListByDepId/" + row.deptId).then(res => {
          var phoneArr = [];
          var alarmTypeStr = [];
          phoneArr = row.empPhone.split(',');
          alarmTypeStr = row.alarmTypeStr.split(',');
          this.checkData = res.data.data;
          for (var n = 0;n < phoneArr.length;n++) {
            for (var i = 0; i < this.checkData.length; i++) {
              if (phoneArr[n] == this.checkData[i].userPhone) {
                this.checkData[i].alarmTypeStr = alarmTypeStr[n];
                this.tableData.push(this.checkData[i]);
              }
            }
          }
        });

        // //console.log(row)
        // var arr = new Array();
        // var empArr = [];
        // empArr=row.empName.split(',');
        // var phoneArr = [];
        // phoneArr=row.empPhone.split(',');
        //
        // for(var i=0;i < empArr.length;i++){
        //   var empPhoneStr =  (phoneArr.length>i)?phoneArr[i]:'';
        //   var emp  =
        //     {
        //       "empName" : empArr[i],
        //       "empPhone" : empPhoneStr
        //     }
        //   arr.push(emp);
        // }

        //this.tableData = arr;

      },


    },
    mounted() {
      this.initSystemId();
    },
  };
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/alarmCorrelation.vue